import { createSlice } from "@reduxjs/toolkit";

export default createSlice({
    name: "sessionId",
    initialState: null,
    reducers: {
        set: (state, action) => action.payload,
    },
});
